(function () {
  'use strict';

  /**
   * <cart-bundle-merge-banner> (Cas D/E) — see snippets/cart-bundle-
   * merge-banner.liquid's own doc comment for the full rationale. Reuses
   * cartChange/cartAdd/fetchCart/refreshCart/setFirstProductIfUnset from
   * assets/cart-bundle-toggle.js via window.CartBundle rather than
   * duplicating them (loaded first — see snippets/cart-line-items.liquid).
   *
   * A single click does everything, with no picker: fetches a fresh
   * cart, finds which of data-simple-variant-ids are currently present
   * as separate lines, removes every one of them, adds 1 unit of
   * data-target-variant-id, and memorizes the EARLIEST of the removed
   * lines as the "first product", set-if-unset.
   *
   * "Earliest" = the HIGHEST index in cart.items, confirmed empirically
   * against this store's own live cart (not assumed): this Shopify setup
   * orders cart.items newest-first (each new add is inserted at index 0,
   * pushing existing lines down), not the more commonly-assumed
   * oldest-first/append order. Re-verify against a fresh /cart.js add
   * sequence if this ever stops holding (e.g. a cart transform change).
   */
  customElements.get('cart-bundle-merge-banner') ||
    customElements.define(
      'cart-bundle-merge-banner',
      class extends HTMLElement {
        connectedCallback() {
          this.switchButton = this.querySelector('[data-bundle-merge-switch]');
          this.boundClick = this.handleClick.bind(this);
          this.switchButton?.addEventListener('click', this.boundClick);
        }

        disconnectedCallback() {
          this.switchButton?.removeEventListener('click', this.boundClick);
        }

        handleClick() {
          if (this.isLoading) return;
          this.setLoading(true);

          const targetVariantId = this.dataset.targetVariantId;
          const simpleVariantIds = (this.dataset.simpleVariantIds || '')
            .split(',')
            .filter(Boolean)
            .map(Number);
          const scope = this.closest('cart-element') || document;

          window.CartBundle.fetchCart()
            .then((cart) => {
              const involvedLines = cart.items
                .map((item, index) => ({item, index}))
                .filter(({item}) => simpleVariantIds.includes(item.variant_id));

              // Cart state moved on since this banner was rendered (e.g.
              // one of the involved lines was removed elsewhere) and
              // there's no longer a real merge to perform — leave the
              // cart untouched; the next refresh re-evaluates from
              // scratch and hides this banner if it no longer applies.
              if (involvedLines.length < 2) return null;

              involvedLines.sort((a, b) => b.index - a.index);
              const firstVariantId = involvedLines[0].item.variant_id;

              // Fade this banner and every involved line out together
              // before touching the cart, the same "real exit, while
              // still connected" treatment assets/cart-bundle-toggle.js
              // gives its own line replacements — see its own doc
              // comment on fadeOutElements() for why.
              const involvedCartItems = involvedLines.map(({item}) =>
                document.querySelector(`[data-item="${item.key}"]`)
              );

              return window.CartBundle.fadeOutElements([this, ...involvedCartItems])
                .then(() =>
                  involvedLines.reduce(
                    (promise, {item}) => promise.then(() => window.CartBundle.cartChange(item.key, 0)),
                    Promise.resolve()
                  )
                )
                .then(() => window.CartBundle.cartAdd([{id: Number(targetVariantId), quantity: 1}]))
                .then(() => window.CartBundle.setFirstProductIfUnset(firstVariantId, cart))
                .then(() => window.CartBundle.refreshCart(scope));
            })
            .catch((error) => console.error('cart-bundle-merge-banner:', error))
            .finally(() => this.setLoading(false));
        }

        setLoading(isLoading) {
          this.isLoading = isLoading;
          this.classList.toggle('is-loading', isLoading);
          this.switchButton?.toggleAttribute('disabled', isLoading);
        }
      }
    );
})();
